import type React from "react";

import { translate } from "app/filters/i18nFilter";
import OptionsMenuDropdown from "app/pages/sales-intelligence/common-components/options-menu/OptionsMenu/OptionsMenuDropdown";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import AiMeetingAgentDropdownItem from "app/pages/sales-intelligence/sub-modules/contacts-search/components/cells/EngageActionsCell/AiMeetingAgentDropdownItem";
import CraftEmailDropdownItem from "app/pages/sales-intelligence/sub-modules/contacts-search/components/cells/EngageActionsCell/CraftEmailDropdownItem";
import WebsitesDynamicsExportItemContainer from "app/pages/sales-intelligence/sub-modules/management/containers/WebsitesDynamicsExportItem/WebsitesDynamicsExportItemContainer";
import WebsitesHubSpotExportItemContainer from "app/pages/sales-intelligence/sub-modules/management/containers/WebsitesHubSpotExportItem/WebsitesHubSpotExportItemContainer";
import WebsitesSalesforceExportItemContainer from "app/pages/sales-intelligence/sub-modules/management/containers/WebsitesSalesforceExportItem/WebsitesSalesforceExportItemContainer";

import { StyledBaseCell, StyledDDItemWrapper } from "./styles";

const ACTIONS_DROPDOWN_WIDTH = 240;

type Props = {
    domain: string;
    isExportQuotaAllowed: boolean;
    onHubSpotExport: VoidFunction;
    onSalesforceExport: VoidFunction;
    onDynamicsExport: VoidFunction;
    onMeetingAgentClick: VoidFunction;
    onCraftEmailClick: VoidFunction;
    onDDToggle: (isOpen: boolean) => void;
};

export const CompanyActionsCell: React.FC<Props> = ({
    domain,
    isExportQuotaAllowed,
    onHubSpotExport,
    onSalesforceExport,
    onDynamicsExport,
    onMeetingAgentClick,
    onCraftEmailClick,
    onDDToggle,
}) => {
    const quotaNotAllowedTooltipContent = isExportQuotaAllowed
        ? undefined
        : translate("si.websites-export.disabled.text");

    const crmNotAllowedTooltipContent = salesSettingsHelper.isCrmIntegrationsEnabled()
        ? undefined
        : translate("si.websites-export.disabled.text");

    return (
        <StyledBaseCell>
            <OptionsMenuDropdown
                id={`company-actions-cell-${domain}`}
                placement="bottom-left"
                buttonIconSize="xs"
                tooltipContent={translate("si.common.more")}
                dropdownWidth={ACTIONS_DROPDOWN_WIDTH}
                onToggle={onDDToggle}
            >
                <StyledDDItemWrapper>
                    <AiMeetingAgentDropdownItem
                        domain={domain}
                        onClick={onMeetingAgentClick}
                    />
                    <CraftEmailDropdownItem
                        domain={domain}
                        onClick={onCraftEmailClick}
                    />
                    <WebsitesSalesforceExportItemContainer
                        onClick={onSalesforceExport}
                        isUseLockedIcon={false}
                        tooltipDisabledContent={quotaNotAllowedTooltipContent || crmNotAllowedTooltipContent}
                    />
                    <WebsitesHubSpotExportItemContainer
                        onClick={onHubSpotExport}
                        isUseLockedIcon={false}
                        tooltipDisabledContent={quotaNotAllowedTooltipContent || crmNotAllowedTooltipContent}
                    />
                    <WebsitesDynamicsExportItemContainer
                        onClick={onDynamicsExport}
                        isUseLockedIcon={false}
                        tooltipDisabledContent={quotaNotAllowedTooltipContent || crmNotAllowedTooltipContent}
                    />
                </StyledDDItemWrapper>
            </OptionsMenuDropdown>
        </StyledBaseCell>
    );
};
